import { z } from "zod"
import { Payment } from "@/types/payment"

export const dialogoLancamentoFormSchema = z.object({
  creditor: z.string().min(1, "Credor obrigatório"),
  payment_date: z.date().or(z.string().min(1, "Data obrigatória")),
  emission_type: z.string().min(1, "Tipo de documento obrigatório"),
  emission_number: z.string().min(1, "Número do documento obrigatório"),
  emission_date: z.string().min(1, "Data obrigatória"),
  amount: z.string().min(1, "Valor obrigatório"),
  fase_orcamento: z.string().min(1, "Fase do orçamento obrigatória"),
  budget_item_id: z.string().min(1, "Sub-item do orçamento obrigatório"),
  observations: z.string().optional(),
})

export type DialogoLancamentoFormData = z.infer<typeof dialogoLancamentoFormSchema>

export interface DialogFormProps {
  payment: Payment
  isEditing: boolean
  isSaving?: boolean
  onSave?: (payment: Payment) => void
  onDelete?: (payment: Payment) => void
  onClose: () => void
}

export interface AcoesLinhaProps {
  onView: () => void
  onEdit: () => void
  onDelete: () => void
}

export interface TabelaLancamentosProps {
  data: Payment[]
  onView: (p: Payment) => void
  onEdit: (p: Payment) => void
  onDelete: (p: Payment) => void
  onSave?: (p: Payment) => void
  navigate: (path: string) => void
  isLoading?: boolean
}

export interface DialogoLancamentoProps {
  payment: Payment | null
  open: boolean
  onClose: () => void
  onSave?: (payment: Payment) => void
  onDelete?: (payment: Payment) => void
  uploadFile?: (file: File, contractId: number) => Promise<string>
  mode?: "view" | "edit"
}

export interface FormButtonsProps { 
  navigate: (path: string) => void; 
  isValid: boolean; 
  isPending: boolean;
  onClose?: () => void;
}